<ion-buttons
  slot="start"
  class="homie-back-btn"
  *ngIf="clientName === 'homie' && url === '/error'"
>
  <ion-back-button
    defaultHref="back_clicked"
    icon="chevron-back-outline"
    class="primary-icon-color"
  ></ion-back-button>
</ion-buttons>
<ion-grid class="ion-no-padding" [style.height]="componentHeight">
  <ion-row
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
    style="height: 100%; flex-direction: column"
  >
    <div class="ion-padding ion-text-center">
      <custom-icon
        [iconName]="image"
        [width]="250"
        [height]="250"
        colorClass="modalIcon"
        style="max-width: 250px; width: 100%; margin: auto"
      ></custom-icon>
      <ion-text>
        <p class="fs-5 font600 error-primary-text-color">
          {{ message | translate }}
        </p>
      </ion-text>
      <ion-button
        *ngIf="fallbackCTA && partnerPid !== 'ent'"
        expand="block"
        [routerLink]="backUrl"
        routerDirection="back"
        (click)="navigateToBackUrlWithReload($event)"
        class="ion-no-margin fs-3 font500 primary-btn"
      >
        {{ fallbackCTA }}
      </ion-button>
      <ion-button
        *ngIf="showModalCloseBtn"
        expand="block"
        (click)="closeModal()"
        class="ion-no-margin fs-3 font500 primary-btn"
      >
        <ion-ripple-effect></ion-ripple-effect>
        {{ "no_data.close_btn" | translate }}
      </ion-button>
    </div>
  </ion-row>
</ion-grid>
